import { getVisibleFilters } from '../../../../utils/filter'

export function isRequestProfileTabEmailsToolbarFilterBarShown({
  availableFilters,
  isSkeleton,
}) {
  return isSkeleton || getVisibleFilters(availableFilters).length > 0
}
